import { render } from "./TargetDealsCard.vue?vue&type=template&id=71fc3291&scoped=true"
import script from "./TargetDealsCard.vue?vue&type=script&lang=js"
export * from "./TargetDealsCard.vue?vue&type=script&lang=js"

import "./TargetDealsCard.vue?vue&type=style&index=0&id=71fc3291&lang=scss&scoped=true"
import "./TargetDealsCard.vue?vue&type=style&index=1&id=71fc3291&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fc3291"]])

export default __exports__